import { render, staticRenderFns } from "./ASnippetCategoryRef.vue?vue&type=template&id=376595e6&"
import script from "./ASnippetCategoryRef.vue?vue&type=script&lang=ts&"
export * from "./ASnippetCategoryRef.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports